import { UnitsUtil } from './unitsUtil';

export interface BmiResult {
  bmi: number;
  centimeter: number;
  kilo: number;
}

const calculateBmiImperial = (feet: number, inch: number, stone: number, pound: number): BmiResult => {
  const centimeter = UnitsUtil.feetToCentimeter(feet) + UnitsUtil.inchToCentimeter(inch);
  const kilo = UnitsUtil.stoneToKilo(stone) + UnitsUtil.poundToKilo(pound);

  return calculateBmi(centimeter, kilo);
};

const calculateBmiMetric = (centimeter: number, kilo: number): BmiResult => {
  return calculateBmi(centimeter, kilo);
};

const calculateBmiAmerican = (feet: number, inch: number, pound: number): BmiResult => {
  const centimeter = UnitsUtil.feetToCentimeter(feet) + UnitsUtil.inchToCentimeter(inch);
  const kilo = UnitsUtil.poundToKilo(pound);
  return calculateBmi(centimeter, kilo);
};

const calculateBmiIndian = (feet: number, inch: number, kilo: number): BmiResult => {
  const centimeter = UnitsUtil.feetToCentimeter(feet) + UnitsUtil.inchToCentimeter(inch);
  return calculateBmi(centimeter, kilo);
};

const calculateBmi = (centimeter: number, kilo: number): BmiResult => {
  const meter = centimeter / 100;
  const bmi = kilo / (meter * meter);
  return { bmi: bmi, centimeter: centimeter, kilo: kilo };
};

export const BmiUtil = {
  calculateBmiImperial,
  calculateBmiMetric,
  calculateBmiAmerican,
  calculateBmiIndian,
  calculateBmi,
};
